import {request,} from '@/common/requestZt.js'
import {ztUrl} from '@/common/const.js'

// 供应商列表信息
export function SupplierList(query) {
    return request.get(ztUrl + '/product/supplier/list', query, localStorage.getItem('middle-token'))
}
